// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import Paging from "./Paging";
import SocialTheme, { processSocialTheme, processSocialThemeArray } from "entity/SocialTheme";
import SocialThemeData from "entity/SocialThemeData";
import SocialThemeInfo, { processSocialThemeInfo } from "entity/SocialThemeInfo";
import SocialThemeType from "enums/SocialThemeType";

import { RestController, RestRequest } from "./RestController";

export default class BackgroundController extends RestController {

    /*
     Create a custom theme
     */

    createCustomTheme(themeData: SocialThemeData): Promise<SocialTheme> {
        let request = new RestRequest("/api/v1/theme/custom", "POST", themeData, undefined);
        return this.request(request, processSocialTheme) as Promise<SocialTheme>;
    }

    /*
     Delete social theme
     */

    deleteCustomTheme(socialThemeId: string): Promise<void> {
        let request = new RestRequest("/api/v1/theme/custom", "DELETE", null, { socialThemeId: socialThemeId });
        return this.requestVoid(request);
    }

    /*
     Get my themes
     */

    getMyThemes(roomWidth: number, roomHeight: number, page?: Paging): Promise<SocialTheme[]> {
        let request = new RestRequest("/api/v1/theme/user", "GET", null, { roomWidth: roomWidth, roomHeight: roomHeight });
        if (page) request.addPaging("", page);

        return this.request(request, processSocialThemeArray) as Promise<SocialTheme[]>;
    }

    /*
     Get social theme
     */

    getSocialTheme(socialThemeId: string): Promise<SocialTheme> {
        let request = new RestRequest("/api/v1/theme", "GET", null, { socialThemeId: socialThemeId });
        return this.request(request, processSocialTheme) as Promise<SocialTheme>;
    }

    /*
     Get theme infos
     */

    getThemeInfos(roomWidth: number, roomHeight: number, page?: Paging): Promise<SocialThemeInfo> {
        let request = new RestRequest("/api/v1/theme/info", "GET", null, { roomWidth: roomWidth, roomHeight: roomHeight });
        if (page) request.addPaging("", page);

        return this.request(request, processSocialThemeInfo) as Promise<SocialThemeInfo>;
    }

    /*
     Get system themes
     */

    getThemes(type: SocialThemeType, roomWidth: number, roomHeight: number, page?: Paging): Promise<SocialTheme[]> {
        let request = new RestRequest("/api/v1/theme/system", "GET", null, { type: type, roomWidth: roomWidth, roomHeight: roomHeight });
        if (page) request.addPaging("", page);

        return this.request(request, processSocialThemeArray) as Promise<SocialTheme[]>;
    }

    /*
     Replace social theme with another one. Returns how many was replaced.
     */

    replaceSocialTheme(currentSocialThemeId: string, newSocialThemeId: string): Promise<number> {
        let request = new RestRequest("/api/v1/theme/custom/replace", "POST", null, { currentSocialThemeId: currentSocialThemeId, newSocialThemeId: newSocialThemeId });
        return this.request(request, null) as Promise<number>;
    }

    /*
     Update social theme
     */

    updateCustomTheme(themeData: SocialThemeData): Promise<SocialTheme> {
        let request = new RestRequest("/api/v1/theme/custom", "PATCH", themeData, undefined);
        return this.request(request, processSocialTheme) as Promise<SocialTheme>;
    }

}
